import { ArrowRight } from "lucide-react";
import { externalLinkProps, installCta, pricingCta } from "../../lib/funnelLinks";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta-section"
      className="px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-[#0F172A] text-[#F8FAFC] rounded-[2rem] overflow-hidden p-10 sm:p-16 lg:p-20 fade-up">
          <div
            aria-hidden
            className="absolute -top-32 -right-32 w-96 h-96 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(143,168,150,0.35) 0%, rgba(143,168,150,0) 70%)",
            }}
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(220,167,115,0.25) 0%, rgba(220,167,115,0) 70%)",
            }}
          />

          <div className="relative">
            <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#F59E0B]">
              You don&apos;t need more pressure
            </p>
            <h2 className="mt-5 font-display text-3xl sm:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.04] max-w-3xl">
              You need a way back in.
            </h2>
            <p className="mt-6 text-lg text-[#cbd5e1] max-w-2xl leading-relaxed">
              Mindrail helps ADHD brains recover from drift, stuckness,
              overload, and lost context — gently, privately, and right inside
              the browser.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href={installCta.href}
                data-testid="final-cta-primary"
                className="inline-flex items-center gap-2 rounded-full bg-[#F8FAFC] text-[#0F172A] px-7 py-4 text-base font-medium hover:bg-white transition-all hover:scale-[1.02]"
                {...externalLinkProps(installCta.external)}
              >
                {installCta.label}
                <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
              </a>
              <a
                href={pricingCta.href}
                data-testid="final-cta-secondary"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-4 text-base font-medium text-[#F8FAFC] transition-all hover:border-white/45 hover:bg-white/10"
              >
                View Pro features
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
